import React from "react";

import "./EmptyData.scss";

export interface IEmptyDataProps {
  theme: "dark" | "light";
  text: string;
}

export const EmptyData: React.FC<React.PropsWithChildren<IEmptyDataProps>> = ({
  theme,
  text,
}) => <div className={`c-empty-data ${theme}`}>{text}</div>;
